import type { TFunction } from 'i18next';
import type { AssessmentResultItemDataFragment } from '../../../Trainee/TraineeReports.api';
import type { CognitiveFitness } from '../../model';

export const buildDefaultCognitivePlaceholder = (
    t: TFunction,
    item: AssessmentResultItemDataFragment
): CognitiveFitness | null => {
    const mi = item.moduleInstance;
    if (!mi?.moduleDefinitionIdentifier) {
        return null;
    }

    return {
        name: mi.name ?? '',
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.cognitiveFitness.scoreLabel'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.avgResponseTimeMs'),
                value: t('traineeReports:na'),
            },
        ],
    };
};

export const buildDefaultNBackPlaceholder = (
    t: TFunction,
    item: AssessmentResultItemDataFragment
): CognitiveFitness | null => {
    const mi = item.moduleInstance;
    if (!mi?.moduleDefinitionIdentifier) {
        return null;
    }

    return {
        name: mi.name ?? '',
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.cognitiveFitness.scoreLabel'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.avgResponseTimeMs'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.dPrime'),
                value: t('traineeReports:na'),
            },
        ],
    };
};

export const buildDigitSpanPlaceholder = (
    t: TFunction,
    item: AssessmentResultItemDataFragment
): CognitiveFitness | null => {
    const mi = item.moduleInstance;
    if (!mi?.moduleDefinitionIdentifier) {
        return null;
    }

    return {
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier,
        name: mi.name ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.cognitiveFitness.maxForwardSpanScore'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.forwardCorrectTrials'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.maxBackwardSpanScore'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.backwardCorrectTrials'),
                value: t('traineeReports:na'),
            },
        ],
    };
};

export const buildAitPlaceholder = (t: TFunction, item: AssessmentResultItemDataFragment): CognitiveFitness | null => {
    const mi = item.moduleInstance;
    if (!mi?.moduleDefinitionIdentifier) {
        return null;
    }

    return {
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier,
        name: mi.name ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.cognitiveFitness.score'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.accuracy'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.flexibility'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.adaptiveSpeed'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.agilityLevel'),
                value: t('traineeReports:na'),
            },
        ],
    };
};
